import { GuardedDeletionService, RegionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RegionCreateDto,
  RegionDto,
  RegionExcelDownloadDto,
  RegionUpdateDto,
} from '../proxy/planning/dtos/region';
import { REGION_CONFIG, REGION_FIELDS } from './region.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-region',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RegionService, ConfirmationService],
  templateUrl: './region.html',
  styleUrl: './region.scss',
})
export class Region extends BaseHierarchicalCrudComponent<
  RegionDto,
  RegionCreateDto,
  RegionUpdateDto,
  RegionExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(RegionService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Region', ids),
  };
  config = REGION_CONFIG;
  fields = REGION_FIELDS;

  protected prepareUpdateDto(data: any, selected: RegionDto): RegionUpdateDto {
    return {
      name: data.name,
      code: data.code,
      storageLocationId: data.storageLocationId,
      countryId: data.countryId,
      locationId: data.locationId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Region';
  }
}
